module.exports = __webpack_public_path__ + "media/images/icons/vertical-align-top-bbf5d2b33eb2417b7d59e34d7a1a55eb.svg";